import { render, staticRenderFns } from "./submission_panel.vue?vue&type=template&id=42f01cbb&scoped=true&"
import script from "./submission_panel.vue?vue&type=script&lang=ts&"
export * from "./submission_panel.vue?vue&type=script&lang=ts&"
import style0 from "./submission_panel.vue?vue&type=style&index=0&id=42f01cbb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f01cbb",
  null
  
)

export default component.exports